import { NgModule } from '@angular/core';
import { SharedModule } from '~app/app/~shared/modules/shared.module';
import { SubscriberAdsLayoutComponent } from './layouts/subscriber-ads-layout/subscriber-ads-layout.component';
import { SubscriberAdsCardComponent } from './components/subscriber-ads-card/subscriber-ads-card.component';
import { SubscriberAdsDatatableComponent } from './components/subscriber-ads-datatable/subscriber-ads-datatable.component';

const DECLARATIONS = [
  SubscriberAdsLayoutComponent,
  SubscriberAdsCardComponent,
  SubscriberAdsDatatableComponent
];

const MODULES = [SharedModule];

// const IMPORT_ONLY_MODULES = [NgxsModule.forFeature([])];

@NgModule({
  declarations: DECLARATIONS,
  // imports: [...MODULES, ...IMPORT_ONLY_MODULES],
  imports: [...MODULES],
  exports: [...MODULES, ...DECLARATIONS],
  providers: []
})
export class SubscriberAdsModule {}
